export const SET_SWIPER_LEVEL = 'SET_SWIPER_LEVEL';
export const SET_DONE_MATERIAL = 'SET_DONE_MATERIAL';
export const REMOVE_DONE_MATERIAL = 'REMOVE_DONE_MATERIAL';
export const SET_WHOLE_RECYCLE_RIGHT = 'SET_WHOLE_RECYCLE_RIGHT';
export const SET_RECYCLE_RIGHT_DATA = 'SET_RECYCLE_RIGHT_DATA';
